// @mui
import { Button, Typography, TextField, Stack } from '@mui/material';
// components
import { styled } from '@mui/material/styles';
import { MotionInView, varFade } from '../../components/animate';


// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
    textAlign: 'center',
    paddingTop: theme.spacing(20),
    paddingBottom: theme.spacing(10),
    paddingLeft:'15%',
    paddingRight:'15%',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  }));

export default function ContactV1({block}) {
  return (
    <RootStyle>
    <Stack spacing={5}>
      <MotionInView variants={varFade().inUp}>
        <Typography variant="h3">
          {block.title}
        </Typography>
      </MotionInView>

      <Stack spacing={3}>
        <MotionInView variants={varFade().inUp}>
          <TextField fullWidth label="Name" />
        </MotionInView>

        <MotionInView variants={varFade().inUp}>
          <TextField fullWidth label="Email" />
        </MotionInView>

        <MotionInView variants={varFade().inUp}>
          <TextField fullWidth label="Subject" />
        </MotionInView>

        <MotionInView variants={varFade().inUp}>
          <TextField fullWidth label="Enter your message here." multiline rows={4} />
        </MotionInView>
      </Stack>

      <MotionInView variants={varFade().inUp}>
        <Button size="large" variant="contained">
          Submit Now
        </Button>
      </MotionInView>
    </Stack>
    </RootStyle>
  );
}
